"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfAnchoredPictureRunExporter = void 0;
var tslib_1 = require("tslib");
var rtf_floating_object_picture_export_strategy_1 = require("./picture/rtf-floating-object-picture-export-strategy");
var rtf_anchored_run_exporter_1 = require("./rtf-anchored-run-exporter");
var RtfAnchoredPictureRunExporter = (function (_super) {
    tslib_1.__extends(RtfAnchoredPictureRunExporter, _super);
    function RtfAnchoredPictureRunExporter(rtfBuilder, pictureRun, imageCache) {
        var _this = _super.call(this, rtfBuilder, pictureRun.anchorInfo, pictureRun.shape, pictureRun.size, pictureRun.info.containerProperties) || this;
        _this.pictureRun = pictureRun;
        _this.imageCache = imageCache;
        return _this;
    }
    RtfAnchoredPictureRunExporter.prototype.getWidth = function () {
        return this.size.actualSize.width;
    };
    RtfAnchoredPictureRunExporter.prototype.getHeight = function () {
        return this.size.actualSize.height;
    };
    RtfAnchoredPictureRunExporter.prototype.exportContent = function () {
        var exportStrategy = new rtf_floating_object_picture_export_strategy_1.RtfFloatingObjectPictureExportStrategy();
        exportStrategy.export(this.rtfBuilder, this.pictureRun.info, this.imageCache, this.pictureRun.info.containerProperties);
    };
    return RtfAnchoredPictureRunExporter;
}(rtf_anchored_run_exporter_1.RtfAnchoredRunExporter));
exports.RtfAnchoredPictureRunExporter = RtfAnchoredPictureRunExporter;
